import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
    addCandidateManually,
    getCandidateById,
    getCandidateList,
    getCandidateNote,
    postCandidateNote,
    postCreateCandidate,
    postEditCandidate,
} from '../service/candidate.service'

// Initial state definition
const initialState = {
    candidateList: [],
    isLoading: false,
    candidateDetails: null, // Fixed typo here from 'cnadidateDetails' to 'candidateDetails'
    error: null,
    candidateId: null,
    candidateDetailLoading: false,
    cnadidateResusmeUrl: null,
    candidateNotes: [],
    resumeFile: null,
    activeTab: '',
    jobId: '',
    filter: {},
    search: '',
    pagination: {
        page: 1,
        limit: 10,
        totalPages: 0,
        totalCount: 0,
        isNext: false,
        skip: 0,
    },
}

// Async thunk to fetch candidates
export const getAllCandidate = createAsyncThunk(
    'candidateSlice/list',
    async ({
        skip = 0,
        limit = 10,
        filter = {},
        search = '',
        sort,
        sortType,
    } = {}) => {
        const response = await getCandidateList(
            skip,
            limit,
            filter,
            search,
            sort,
            sortType
        )
        return response?.data
    }
)

export const candidateById = createAsyncThunk(
    'candidateSlice/details',
    async ({ id, activeTab }, { rejectWithValue }) => {
        const response = await getCandidateById(id, activeTab)
        return response?.data
    }
)

export const candidateNotesList = createAsyncThunk(
    'candidateSlice/notes',
    async ({ candidateId }, { rejectWithValue }) => {
        const response = await getCandidateNote(candidateId)
        return response?.data
    }
)

export const candidateCreate = async (payload) => {
    return await postCreateCandidate(payload)
}

export const candidateEdit = async (activeTab, id, payload) => {
    return await postEditCandidate(activeTab, id, payload)
}
export const candidateAddNote = async (CandidateId, payload) => {
    return await postCandidateNote(CandidateId, payload)
}

export const candidateCreateManually = createAsyncThunk(
    'candidateSlice/addCandidateManually',
    async (payload = {}) => {
        const response = await addCandidateManually(payload)
        return response
    }
)

// Slice definition
export const candidateSlice = createSlice({
    name: 'candidateSlice',
    initialState,
    reducers: {
        setCandidateId: (state, action) => {
            state.candidateId = action.payload
        },
        clearCandidateDetails: (state, action) => {
            state.candidateDetails = null
        },
        setCandidateResumeUrl: (state, action) => {
            state.cnadidateResusmeUrl = action.payload
        },

        resetcandidateDetails: (state, action) => {
            state.candidateDetails = action.payload
        },
        addNewNotesPreNotes: (state, action) => {
            state.candidateNotes = [...state.candidateNotes, action.payload]
        },
        applyFilter: (state, action) => {
            state.filter = action.payload
        },
        resetFilter: (state, action) => {
            state.filter = {}
        },
        setResumeFile: (state, action) => {
            state.resumeFile = action.payload
        },
        setActiveTab: (state, action) => {
            state.activeTab = action.payload
        },
        setActiveJobId: (state, action) => {
            state.jobId = action.payload
        },
        setSearch: (state, action) => {
            state.search = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllCandidate.pending, (state) => {
                state.isLoading = true
            })

            .addCase(getAllCandidate.fulfilled, (state, action) => {
                const { result } = action.payload
                state.candidateList = result
                state.pagination.page = action?.payload?.page
                state.pagination.limit = action?.payload?.limit
                state.pagination.totalCount = action?.payload?.totalCount
                state.pagination.totalPages = action?.payload?.totalPages
                state.pagination.isNext = action?.payload?.isNext
                state.pagination.skip = action?.payload?.skip
                state.isLoading = false
                state.error = null
            })
            .addCase(getAllCandidate.rejected, (state, action) => {
                state.candidateList = []
                state.isLoading = false
                state.error = action.payload.error
            })
            .addCase(candidateById.pending, (state) => {
                state.isLoading = true
            })

            .addCase(candidateById.fulfilled, (state, action) => {
                state.candidateDetails = action.payload.data
                state.isLoading = false
                state.error = null
            })
            .addCase(candidateById.rejected, (state, action) => {
                state.candidateDetails = null
                state.isLoading = false
                state.error = action.payload.error
            })
            .addCase(candidateNotesList.pending, (state) => {
                state.isLoading = true
            })
            .addCase(candidateNotesList.fulfilled, (state, action) => {
                state.candidateNotes = action.payload.result
                state.isLoading = false
                state.error = null
            })
            .addCase(candidateNotesList.rejected, (state, action) => {
                state.candidateNotes = null
                state.isLoading = false
                state.error = action.payload.error
            })
    },
})

export default candidateSlice.reducer

// Export actions (if any)
export const {
    setCandidateId,
    setCandidateResumeUrl,
    resetcandidateDetails,
    applyFilter,
    setResumeFile,
    resetFilter,
    setActiveTab,
    clearCandidateDetails,
    setSearch,
    setActiveJobId,
} = candidateSlice.actions
